import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  root: {
    padding: spacing(2),
    width: "100%",
  },
  input: {
    boxShadow:
      "0px 1px 5px 0px #6372822E,  0px 3px 4px 0px #6372821A, 0px 2px 4px 0px #6372821F",
    borderRadius: spacing(1),
    padding: spacing(1),
    "&:before, &:after": {
      border: "none !important",
    },
    "& input": {
      paddingLeft: spacing(1),
    },
  },
  divider: {
    height: spacing(3),
  },
  iconButton: {
    boxShadow: "none",
    padding: spacing(1),
  },
}));
